import {MainScreenDefaultBox} from './main-screen.default.box';
import {styledByTheme} from '../../../themes/architecture/styled-by-theme';
import {MainScreenCasino888Box} from './main-screen.casino888.box';
import {MainScreenHarrahsBox} from './main-screen.harrahs.box';
import {MainScreenWsopBox} from './main-screen.wsop.box';
import {MainScreenCipBox} from './main-screen.cip.box';

export const MainScreenBox = styledByTheme(MainScreenDefaultBox)
    .forCasino888(MainScreenCasino888Box)
    .forHarrahs(MainScreenHarrahsBox)
    .forWsop(MainScreenWsopBox)
    .forCip(MainScreenCipBox)
    .apply();
